module.exports = __webpack_public_path__ + "img/p15.fe9f3ca8.png";